const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
};

const LISTING_STATUS = {
  PENDING: 'Pending',
  POSTED: 'Posted',
  DECLINED: 'Declined',
  PUBLISHING: 'Publishing',
  INACTIVE: 'Inactive',
};

const SYNDICATION_OVERVIEW_STATUS = {
  INACTIVE: 'inactive',
  PUBLISHING: 'publishing',
  PUBLISHED: 'published',
  PARTIALLY_PUBLISHED: 'partiallyPublished',
  DECLINED: 'declined',
  WAITLISTED: 'waitlisted',
};

const PROPERTY_TYPES = {
  COMMUNITY: 'Entire Apartment Community',
  CONDO: 'Condo / Apartment Unit',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhouse',
};

const { RENTAL, ROOM, SALE } = LISTING_TYPES;
const { COMMUNITY, CONDO, HOUSE, TOWNHOUSE } = PROPERTY_TYPES;

const LISTING_TYPES_BY_CODE = {
  1: RENTAL,
  2: SALE,
  5: ROOM,
};

const LISTING_CODES_BY_TYPE = {
  [RENTAL]: 1,
  [SALE]: 2,
  [ROOM]: 5,
};

const PROPERTY_TYPES_BY_CODE = {
  1: COMMUNITY,
  2: COMMUNITY,
  3: COMMUNITY,
  5: CONDO,
  6: HOUSE,
  7: TOWNHOUSE,
};

const PROPERTY_CODES_BY_TYPE = {
  [COMMUNITY]: 1,
  // not currently using these two
  // GARDEN: 2,
  // MEDIUM: 3,
  [CONDO]: 5,
  [HOUSE]: 6,
  [TOWNHOUSE]: 7,
};

// TODO: replace instances with values from FreemiumConstants
const PRODUCT_TYPE_NAME_TO_ID = {
  FREE: 5,
  PREMIUM: 6,
};

const PRODUCT_TYPE_ID_TO_NAME = {
  5: 'Free',
  6: 'Premium',
};

const ERROR_CODE = {
  IS_MULTI_FAMILY_RESTRICTED: 'isMultiFamilyRestricted',
};

const PropertyConstants = {
  LISTING_TYPES,
  LISTING_STATUS,
  PROPERTY_TYPES,
  LISTING_TYPES_BY_CODE,
  LISTING_CODES_BY_TYPE,
  PRODUCT_TYPE_NAME_TO_ID,
  PRODUCT_TYPE_ID_TO_NAME,
  PROPERTY_CODES_BY_TYPE,
  PROPERTY_TYPES_BY_CODE,
  SYNDICATION_OVERVIEW_STATUS,
  ERROR_CODE,
};

export default PropertyConstants;
